import { Dialog } from '@mui/material';
import { X } from 'feather-icons-react/build/IconComponents';
import React, { useState } from 'react'
import { Transition } from './Transition';
import { t } from 'i18next';
import TextareaComponent from '../Component/FormInput/TextareaComponent';
import { ButtonComponent } from '@shopeasy-dashboard-ui/ui-library';

const SourceCode = ({ open, htmlCode, closeCode, saveHTML }) => {
    const [html, setHtml] = useState({ htmlPP: open, code: htmlCode });
    const [isChange, setIsChange] = useState(false)
    return (
        <Dialog
            open={html?.htmlPP}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => {
                if (isChange && window.confirm("Are You Sure to Leave?. Your recent changes will not be included.")) {
                    closeCode();
                    setIsChange(false)
                }else{
                    closeCode();
                }
            }}
            aria-describedby="alert-dialog-slide-description"
        >
            <div className='w-full md:w-[35rem]  p-5 rounded-[6px]  secondary-bg-color shadow dark:bg-gray-700'>
                <div>
                    <label className='flex items-center justify-between  text-primary text-md font-medium mb-2' htmlFor='product_name'>
                    {t('lang_source_code')}
                        <ButtonComponent
                            variant="ghost"
                            size="sm"
                            type="button"
                            className="close-btn !p-1"
                            onClick={(e) => {
                                e.preventDefault();
                                if (isChange && window.confirm("Are You Sure to Leave?. Your recent changes will not be included.")) {
                                    closeCode();
                                    setIsChange(false)
                                }else{
                                    closeCode()
                                }
                            }}
                        >
                            <X className="w-4 h-4" />
                        </ButtonComponent>
                    </label>
                    <hr className='my-4 main-border-color' />
                    <TextareaComponent
                        rows={16}
                        value={html?.code}
                        onChange={(e) => { setHtml({ ...html, code: e.target.value }); setIsChange(true) }}
                        placeholder='<p>Code here<p/>'
                    />
                </div>
                <div className='mt-4 w-full'>
                    <ButtonComponent
                        variant='primary'
                        className='w-full'
                        onClick={() => saveHTML(html?.code)}
                    >
                        {t('lang_Edit_Source_Code')}
                    </ButtonComponent>
                </div>
            </div>
        </Dialog>
    )
}

export default SourceCode